import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import type { PaymentStatus } from 'modules/payroll_bundle/components/common/components/ShowStatus'
import ShowStatus from 'modules/payroll_bundle/components/common/components/ShowStatus'
import type { ResultRowData } from 'modules/payroll_bundle/lib/resultsTableData'
import { TabCard } from 'modules/payroll_bundle/pages/ResultsAndPaymentsPage/_common/_TabCard'

import { Tabs } from './types'

interface Props {
  currentTab: Tabs
  onChangeTab: (tab: Tabs) => void
  selectedResultsRowData: ResultRowData
  employeePaymentsStatus: PaymentStatus
}

const Header = ({
  employeePaymentsStatus,
  selectedResultsRowData,
  currentTab,
  onChangeTab,
}: Props) => {
  const createAtDate = moment(selectedResultsRowData.createdAt)

  return (
    <Box>
      <Box alignItems="center" gap="s8" padding="s32">
        <Text.Header2>{selectedResultsRowData.employee.access.fullName}</Text.Header2>
        <Text.Normal>
          {createAtDate.format('MMMM')} {createAtDate.year()}
        </Text.Normal>
        <ShowStatus status={employeePaymentsStatus} />
      </Box>
      <Box
        border={{
          bottom: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        width="full"
        flexDirection="row"
        justifyContent="center"
        gap="s24"
      >
        <TabCard
          text={i18n.t('payroll_bundle.results_payments.results.payroll')}
          isSelected={currentTab === Tabs.Results}
          setSelected={() => onChangeTab(Tabs.Results)}
        />
        <TabCard
          text={i18n.t('payroll_bundle.results_payments.payments.title')}
          isSelected={currentTab === Tabs.Payments}
          setSelected={() => onChangeTab(Tabs.Payments)}
        />
      </Box>
    </Box>
  )
}

export default Header
